import { Expedition } from "../../types";
import style from "./ExpeditionBanner.module.css";

type ExpeditionBannerProps = {
	expedition: Expedition;
};

const ExpeditionBanner: React.FC<ExpeditionBannerProps> = ({ expedition }) => {
	return (
		<div className={style.bannerContainer}>
			<img className={style.bannerImage} src={expedition?.banner} />
			<div className={style.bannerInfo}>
				<p>{expedition?.name}</p>
			</div>
			<div className={style.bannerOverlay} />
		</div>
	);
};

export { ExpeditionBanner };
